const setWeekReservation = (state, action) => {
  const { locationWeekId, attending } = action

  return state
    .filter(wr => wr.locationWeekId !== locationWeekId)
    .concat({
      locationWeekId,
      attending
    })
}

export default setWeekReservation
